import React, { Component } from 'react';
import ReactTable from "react-table";
import { CSVLink } from "react-csv";
import 'react-table/react-table.css';

const columns = [
  { Header: "SKU", accessor: "pr_sku", width: 120 },
  { Header: "Description", accessor: "pr_desc", width: 200 },
  { Header: "UPC", accessor: "pr_upc", width: 120 },

  { Header: "Blem #", accessor: "ri_blem_number", width: 100 },
  { Header: "Location", accessor: "ri_location", width: 100 },

  { Header: "Total Qty", accessor: "blem_qty_total", width: 90 },
  { Header: "Sold Qty", accessor: "blem_qty_sold", width: 90 },
  { Header: "Available Qty", accessor: "blem_qty_available", width: 110 },

  { Header: "Last Updated", accessor: "ri_date_updated", width: 140 }
];

class InventoryBlemReport extends Component {

  state = {
    inventoryitems: [],
    cl_id: localStorage.getItem('headerClientId'),
    userToken: localStorage.getItem('userToken')
  };

  componentDidMount() {
    this.loadReport();
  }

  loadReport = () => {
    fetch(
      `${process.env.REACT_APP_NODE_ROOT_URL}/reports/inventory/blem/${this.state.cl_id}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'bwToken': this.state.userToken
        }
      }
    )
      .then(res => res.json())
      .then(inventoryitems => this.setState({ inventoryitems }));
  };

  render() {
    return (
      <div className="page-wrapper">
        <div className="row page-titles">
          <div className="col-md-12 align-self-center">
            <h3 className="text-primary">Blem Inventory Report</h3>
          </div>
        </div>

        <div className="container-fluid">
          <CSVLink
            data={this.state.inventoryitems}
            filename="blem-inventory.csv"
            className="btn btn-info btn-sm"
          >
            Download CSV
          </CSVLink>

          <ReactTable
            data={this.state.inventoryitems}
            columns={columns}
            filterable
            defaultPageSize={50}
            className="-striped -highlight"
            noDataText="Loading blem inventory..."
          />
        </div>
      </div>
    );
  }
}

export default InventoryBlemReport;
